import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem, isLoading } from 'src/reducers/common/itemReducer';
import Loading from 'src/components/Loading';
import PayrollAllowanceDetail from './PayrollAllowanceDetail';
import PayrollDeductionDetail from './PayrollDeductionDetail';
import PayrollSummaryDetail from './PayrollSummaryDetail';
import PayrollAttendanceDetail from './PayrollAttendanceDetail';
import PayrollActionSection from './PayrollActionSection';
import styles from './PayrollTableData.scss';
import NotificationSection from './NotificationSection';

const PayrollDetailShow = ({ allPayrolls = [], isFetchingPayslip, selectingPayroll }) => {
  // 給与がない時の画面
  if (_.isEmpty(allPayrolls) && !isFetchingPayslip) {
    return <NotificationSection />;
  }

  return (
    <div className="l-wrap-xl l-contents-wrap">
      <PayrollActionSection />

      <div className={styles.payment}>
        {isFetchingPayslip ? (
          <Loading />
        ) : selectingPayroll && selectingPayroll?.isReleased ? (
          <>
            <PayrollAttendanceDetail payroll={selectingPayroll} />
            <PayrollAllowanceDetail payroll={selectingPayroll} earnings={selectingPayroll.earnings} />
            <PayrollDeductionDetail payroll={selectingPayroll} deductions={selectingPayroll.deductions} />
            <PayrollSummaryDetail payroll={selectingPayroll} />
          </>
        ) : (
          <NotificationSection payslip={selectingPayroll} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  allPayrolls: (getItem(REDUCER_NAME, state) || {}).allPayrolls,
  selectingPayroll: getItem(REDUCER_NAME, state).selectingPayroll || {},
  isFetchingPayslip: isLoading(REDUCER_NAME, state)
});

export default connect(mapStateToProps)(PayrollDetailShow);
